<div class="cm-inspector-content">
    @if ($node(); as cut) {
        <cm-inspector-section>
            <ng-container cm-content>
                <cm-value-slot [node]="cut" [key]="'name'" [label]="'Name'"></cm-value-slot>
                <cm-value-slot
                    [node]="cut"
                    [key]="'materialAssignment'"
                    (requestUpdate)="onCutMaterialAssignmentChanged($event)"
                    [materialAssignmentLikeClass]="'MattressMaterialAssignment'"
                >
                </cm-value-slot>
                <cm-value-slot
                    [node]="$node()"
                    [key]="'fabricLayout'"
                    [label]="'Fabric Layout'"
                    [selectionPossibilities]="mattressFabricLayoutSelectionPossibilities"
                >
                </cm-value-slot>
            </ng-container>
        </cm-inspector-section>

        <cm-inspector-section>
            <ng-container cm-title>Conditions </ng-container>
            <ng-container cm-content>
                @for (condition of $conditions(); track $index) {
                    <div class="cm-cut-condition">
                        <div class="cm-cut-condition-left-side">
                            <cm-value-slot
                                [node]="$node()"
                                [key]="'conditions'"
                                [subKey]="[$index, 'curve']"
                                [label]="'Curve'"
                                [selectionPossibilities]="$conditionCurveSelectionPossibilities()"
                            ></cm-value-slot>
                            <cm-value-slot
                                [node]="$node()"
                                [key]="'conditions'"
                                [subKey]="[$index, 'side']"
                                [label]="'Side'"
                                [selectionPossibilities]="conditionSideSelectionPossibilities"
                            ></cm-value-slot>
                        </div>
                        <div class="cm-cut-condition-right-side">
                            <i class="far fa-trash" matTooltip="Remove condition" (click)="removeCutCondition($index)"></i>
                        </div>
                    </div>
                }
                <cm-list-item (click)="addCutCondition()">
                    <ng-container cm-pre-title>
                        <div>
                            <i class="far fa-plus"></i>
                        </div>
                    </ng-container>
                    <ng-container cm-title> Add a cut condition </ng-container>
                </cm-list-item>
            </ng-container>
        </cm-inspector-section>
    }
</div>
